import {
	DELETE_SCENARIO,
	SAVE_SCENARIO,
	REFRESH_SCENARIO,
	START_SCENARIO,
	SCENARIOS_CHANGED,
	GET_SCENARIOS,
	FETCH_V4_SCENARIOS,
	REFRESH_V4_SCENARIO_LAST_TRIGGERED,
	V4_SCENARIOS_LOADED,
	V4_SCENARIO_DEDUP_UPDATED,
	V4_SCENARIO_LAST_TRIGGERED_UPDATED,
} from '../constants/scenario.constants';

export const deleteScenario = scenario => ({ type: DELETE_SCENARIO, scenario });
// callback(failure): null once saved, else { error, actionErrors }.
export const saveScenario = (scenario, callback) => ({ type: SAVE_SCENARIO, scenario, callback});
export const refreshScenario = scenario => ({ type: REFRESH_SCENARIO, scenario});
export const getScenarios = scenario => ({ type: GET_SCENARIOS, scenario});
export const startScenario = (scenarioId, payload) => ({ type: START_SCENARIO, scenarioId, payload});
export const scenariosChanged = (scenarios) => ({ type: SCENARIOS_CHANGED, scenarios});
export const fetchV4Scenarios = () => ({ type: FETCH_V4_SCENARIOS });
export const refreshV4ScenarioLastTriggered = (scenarioId, accountId) => ({
	type: REFRESH_V4_SCENARIO_LAST_TRIGGERED,
	scenarioId,
	accountId,
});
export const v4ScenariosLoaded = (scenarios, dedupV4Uuids) => ({
	type: V4_SCENARIOS_LOADED,
	scenarios,
	dedupV4Uuids,
});
export const v4ScenarioDedupUpdated = (dedupV4Uuids) => ({
	type: V4_SCENARIO_DEDUP_UPDATED,
	dedupV4Uuids,
});
export const v4ScenarioLastTriggeredUpdated = (scenarioId, lastTriggeredAt) => ({
	type: V4_SCENARIO_LAST_TRIGGERED_UPDATED,
	scenarioId,
	lastTriggeredAt,
});
